import { render, staticRenderFns } from "./ModalDoctorCreateEdit.vue?vue&type=template&id=457e0a54&"
import script from "./ModalDoctorCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ModalDoctorCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports